module.exports = __webpack_public_path__ + "398f44a56a2f51e1b7b17cee45e5aaf8.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/WF.svg
// module id = 7vYA
// module chunks = 0